module.exports = __webpack_public_path__ + "img/xiaohui2.3f4d62cc.jpg";